/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import { ThunkDispatch } from 'redux-thunk';
import ActionCreator from '../action-creator';
import { RootState } from '..';

export interface UserPayload {
  uid: string;
  created?: string;
  modified?: string;
  email?: string;
  airlineCode?: string;
  username: string;
  role?: [string];
}

export const ActionCreators = {
  ReceiveInitApp: new ActionCreator<'ReceiveInitApp', UserPayload>('ReceiveInitApp'),
};

export type Action = typeof ActionCreators[keyof typeof ActionCreators];

export function init(): any {
  return (dispatch: ThunkDispatch<RootState, undefined, Action>, getState: () => RootState) =>
    new Promise(async (resolve, reject) => {
      try {
        // TODO: enable once the user api is available
        /* const user = access_token
          ? await ajax
              .get('/user')
              .pipe(map((e: AjaxResponse | {}) => (e as AjaxResponse).response))
              .toPromise()
          : undefined; 
        */
        const user = {
          uid: '',
          username: '',
        };

        dispatch(ActionCreators.ReceiveInitApp.create(user) as Action);
        resolve({});
      } catch (error) {
        reject(error);
      }
    });
}
